// import Vue from "./directives"
// Make sure to register before importing any components
import {library} from '@fortawesome/fontawesome-svg-core'
import {faSquare, faCheckSquare} from '@fortawesome/free-regular-svg-icons'
import {FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText} from '@fortawesome/vue-fontawesome'

import './class-component-hooks'
import './filters';
import Vue from './filter';
import router from "./router";

import App from "./App.vue";
import VueResource from 'vue-resource';
import store from './store';
// import VueForm from 'vue-form';
import apolloProvider from '@/graphql/apolloProvider';

import ElementUI from 'element-ui';

import SingleImgUpload from '@/components/common/singleImgUpload.vue';
import MultiImgUpload from '@/components/common/multiImgUpload.vue';
import MultiFileUpload from '@/components/common/multiFileUpload.vue';
import dateView from '@/components/common/dateView.vue';
import simpleFileUpload from '@/components/common/simpleFileUpload.vue';
import excelExport from '@/components/common/excelExport.vue';
import pdfExport from '@/components/common/pdfExport.vue';
import printHtml from '@/components/common/printHtml.vue';
import MaterialUnitSelect from '@/components/common/MaterialUnitSelect.vue';
// import 'element-ui/lib/theme-chalk/index.css';
// import './theme/index.css'

import d2Admin from '@/plugin/d2admin';
import vueLodash from '@/plugin/lodash';
// import vueNanoid from '@/plugin/nanoid';
import i18n from './i18n';
import {frameInRoutes} from '@/router/routes';
import menuHeader from '@/menu/header';
import menuAside from '@/menu/aside';

import * as $ from 'jquery';

import '../src/scss/searchAndSelectInput.scss'
Vue.use(d2Admin);
Vue.use(vueLodash);


import print from '@/plugin/jQuery.print';
// Vue.use(vueNanoid);


library.add(
  faSquare, faCheckSquare,
);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.component('font-awesome-layers-text', FontAwesomeLayersText);

// Vue.use(VueForm);
// Vue.use(ElementUI, {
//   size: 'base', // set element-ui default size
// });
// Vue.use(VueResource);


Vue.component('single-img-upload', SingleImgUpload);
Vue.component('multi-img-upload', MultiImgUpload);
Vue.component('multi-file-upload', MultiFileUpload);
Vue.component('simple-file-upload', simpleFileUpload);
Vue.component('dateView', dateView);
Vue.component('excelExport', excelExport);
Vue.component('pdfExport', pdfExport);
Vue.component('printHtml', printHtml);
Vue.component('material-unit-select', MaterialUnitSelect);
// Vue.use(Element, {
//   size: 'small', // set element-ui default size
// })
// import MintUI from 'mint-ui';
// import 'mint-ui/lib/style.css'
// Vue.use(MintUI)

//@ts-ignore
// Vue.http.interceptors.push(function (request: any, next: any) {
//   if (request.method === 'GET') {
//     Vue.prototype.$indicator.open({
//       text: '数据加载中...',
//       spinnerType: 'fading-circle'
//     })
//   }
//   next(function (response: any) {
//     if (request.method === 'GET') {
//       Vue.prototype.$indicator.close()
//     }
//   })
// })


function GViewFile(file: any) {
  store.commit('fileExtra/setFile', file);
}

function GViewFileList(list: any[],index:number) {
  store.commit('fileExtra/setFileList',{list:list,index:index>0?index:0});
}


Vue.prototype.GViewFile = GViewFile;
Vue.prototype.GViewFileList = GViewFileList;
Vue.prototype.$ = $;
Vue.use(print);

new Vue({
  router,
  store,
  i18n,
  apolloProvider,
  render: (h) => h(App),
  created() {
    // 处理路由 得到每一级的路由设置
    this.$store.commit('d2admin/page/init', frameInRoutes)
    // 设置顶栏菜单
    this.$store.commit('d2admin/menu/headerSet', menuHeader)

    // 设置侧边栏菜单
    // this.$store.commit('d2admin/menu/asideSet', menuAside)
    // 初始化菜单搜索功能
    this.$store.commit('d2admin/search/init', menuHeader)
  },
  mounted() {
    // 展示系统信息
    this.$store.commit('d2admin/releases/versionShow')
    // 用户登录后从数据库加载一系列的设置
    this.$store.dispatch('d2admin/account/load')
    // 获取并记录用户 UA
    this.$store.commit('d2admin/ua/get')
    // 初始化全屏监听
    this.$store.dispatch('d2admin/fullscreen/listen')
  }
}).$mount('#app');

// const app = new Vue({
//   el: "#app",
//   store,
//   router: router,
//   render: h => h(App)
// });
// store.dispatch('commonAsync');
